// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"150":"54441c11237ab131","334":"669a261380374549","359":"6a6ded90d6f65945","366":"960e457bb635ae8b","608":"138a82b4dacdca4f","765":"8da120ff3863f2f6"}[chunkId] + ".js";
};